import { render, staticRenderFns } from "./PanelCreateTask.vue?vue&type=template&id=f03fa218&scoped=true&"
import script from "./PanelCreateTask.vue?vue&type=script&lang=js&"
export * from "./PanelCreateTask.vue?vue&type=script&lang=js&"
import style0 from "./PanelCreateTask.vue?vue&type=style&index=0&id=f03fa218&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03fa218",
  null
  
)

export default component.exports